// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"NotFound_notFoundContainer__7-5OD","homeLink":"NotFound_homeLink__P-EkH"};